import React, { useEffect, useRef } from "react";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import moment from "moment";
import $ from "jquery";

function ListadoSolicitudesCambioCic({
  solicitudesDeCambioCic,
  ObtengaDatosSolicitud = null,
}) {
  const tableRef = useRef();

  useEffect(() => {
    let incializarDataTable = false;

    $.fn.dataTable.ext.errMode = "throw";
    $.fn.dataTable.moment("DD/MM/YYYY hh:mm:ss a");

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      processing: true,
      destroy: true,
      data: solicitudesDeCambioCic,
      order: [[2, "desc"]],
      columns: [
        {
          title: "Consecutivo",
          data: "consecutivo",
          render: function (row) {
            return (
              "<button class='btn btn-link js-seleccion' >" + row + "</button>"
            );
          },
        },
        {
          title: "Entidad",
          data: "entidad.alias",
        },
        {
          title: "Tipo Identificación",
          data: "identificacionDeudor.tipoPersona.nombre",
        },
        {
          title: "Deudor",
          data: "identificacionDeudor.codigo",
        },
        {
          title: "Nombre de Deudor",
          data: "nombreDeudor",
        },
        {
          title: "Usuario Incluye",
          data: "usuarioIncluyeSolicitud",
        },
        {
          title: "Fecha de Inclusión",
          data: "fechaRegistroSolicitud",
          render: function (row) {
            return row !== null
              ? moment(row).format("DD/MM/YYYY hh:mm:ss a")
              : "";
          },
        },
        {
          title: "Último Usuario Tramitador",
          data: "ultimoTramitador",
        },
        {
          title: "Estado",
          data: "estado.descripcion",
        },
        {
          title: "Tipo Solicitud",
          data: "tipoSolicitudCambio.descripcion",
        },
      ],
    });

    const dataTable = "ListadoSolicitudesCambioCIC";
    const datosDataTable = JSON.parse(localStorage.getItem(dataTable));

    tabla.page
      .len(Number(datosDataTable?.filasPorPagina))
      .page(Number(datosDataTable?.paginaActual))
      .draw("page");

    tabla.on("init.dt", function () {
      incializarDataTable = true;
      actualizarDatosDatatable();
    });

    tabla.on("length.dt page.dt", function () {
      actualizarDatosDatatable();
    });

    function actualizarDatosDatatable() {
      localStorage.setItem(
        dataTable,
        JSON.stringify({
          paginaActual: incializarDataTable ? 0 : tabla.page.info().page,
          filasPorPagina: incializarDataTable ? 10 : tabla.page.info().length,
        })
      );
    }

    tabla.off("click");

    tabla.on("click", ".js-seleccion", function () {
      const tr = $(this).closest("tr");
      let rowData = tabla.row(tr).data();
      ObtengaDatosSolicitud(rowData);
    });
  }, [solicitudesDeCambioCic, ObtengaDatosSolicitud]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">
          Solicitudes de Cambio CIC
        </h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}
export default ListadoSolicitudesCambioCic;
